"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latestPricingContextModuleUrl = exports["default"] = void 0;
var latestPricingContextModuleUrl = exports.latestPricingContextModuleUrl = "https://pricing-context-module.products.vpsvc.com/static/v3/pricing-context-module.min.js";

var _default = exports["default"] = {
  latestPricingContextModuleUrl: latestPricingContextModuleUrl
};